/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */

import { Injectable, Inject, LOCALE_ID } from "@angular/core";
import { LocalDataService } from "src/app/shared/services/local-data.service";
import { AppSettingsStorageService } from "src/app/shared/app-settings-storage.service";
import { CurrencyPipe } from "@angular/common";
import { SaleTaxReport } from "./sale-tax-report";
import { HttpClient } from "@angular/common/http";
import { AuthService } from "src/app/shared/services/auth.service";
import * as moment from "moment";
@Injectable({
  providedIn: "root",
})
export class SaleTaxReportLocalDataService extends LocalDataService {
  constructor(
    protected http: HttpClient,
    protected authService: AuthService,
    private appSettingsService: AppSettingsStorageService,
    @Inject(LOCALE_ID) private localeId: string
  ) {
    super(http, authService);
  }

  afterFetch(object, model: string) {
    const currency = this.appSettingsService.getZone().defaultCurrencyIsoCode;
    const currencyFormatter = new CurrencyPipe(this.localeId);

    Object.keys(object)
      .filter((key) => !Object.keys(new SaleTaxReport()).includes(key))
      .forEach((key) => {
        if (key.includes("-taxRate")) {
          object[key] = object[key] + " %";
        } else if (!key.includes("-taxAccountNo") && !key.includes("-taxCalcType") && !key.includes("-fundReceiver")) {
          object[key] = currencyFormatter.transform(object[key], currency, "code", "1.2");
        }
      });

    object.totalAmountCalculated = currencyFormatter.transform(object.totalAmountCalculated, currency, "code", "1.2");
    object.subTotal = currencyFormatter.transform(object.subTotal, currency, "code", "1.2");
  }

  getSaleTaxReport(
    storeId: number,
    stationId: number,
    dateFrom: Date | string,
    dateTo: Date | string,
    accountId = 0,
    userId = 0
  ) {
    const timeTo = moment(dateTo).format("HH:mm:ss");
    const timeFrom = moment(dateFrom).format("HH:mm:ss");
    dateTo = moment(dateTo).format("YYYY-MM-DD");
    dateFrom = moment(dateFrom).format("YYYY-MM-DD");
    const queryParams = {
      dateFrom,
      dateTo,
      timeFrom,
      timeTo,
      accountId,
      userId,
      stationId,
    };

    return this._getRequest<SaleTaxReport[]>(this.webUrl + "repSaleTax/" + storeId, queryParams);
  }
}

/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */
